// Which conversation the screen is showing, for the top bar's Debug menu. The conversation
// panel says so while it is mounted; the menu, which sits in the bar above it, reads it.

import { useSyncExternalStore } from 'react';

let current: string | null = null;
const listeners = new Set<() => void>();

export function setShownThread(threadId: string | null): void {
  if (current === threadId) {
    return;
  }
  current = threadId;
  listeners.forEach((listener) => listener());
}

export function useShownThread(): string | null {
  return useSyncExternalStore(
    (listener) => {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    () => current,
    () => null,
  );
}
